import React from "react";
import { EventLayer } from "./event-layer";
import { useTranslations } from "../../../../hooks/use-translations";
import _ from "lodash";
import { useLanguage } from "../../../../hooks/use-language";

export const TimeZones = ({ list, visible, setVisible }) => {
	const lang = useLanguage();
	const texts = useTranslations({ section: "comunidad_club", lang: lang });

	return (
		<EventLayer title={_.get(texts, 'makemake_en_vivo.evento.boton.horarios') || "Horarios"} visible={visible} setVisible={setVisible}>
			<ul className="d-flex w-100 flex-column flex-grow-1">
				{list?.map((item, i) => {
					return (
						<li
							key={i}
							className="onbackground-primary--color font-weight-bold secondary-font"
						>
							{item}
						</li>
					);
				})}
			</ul>
		</EventLayer>
	);
};
